class HomeHeroSearchForm {
	constructor() {
		this.dropDownTriggers = document.querySelectorAll('.block-home-hero__form-item-trigger');
		this.filterTriggers = document.querySelectorAll('.block-home-hero__form-item-filter');
		this.allDropdowns = document.querySelectorAll('.block-home-hero__form-item-terms');
		this.form = document.querySelectorAll('.block-home-hero__form');
		this.header = document.querySelector('.main-header');
	}

	getElOffset(el) {
		const rect = el.getBoundingClientRect();

		return {
			top: rect.top + window.pageYOffset,
			left: rect.left + window.pageXOffset,
		};
	}

	setDropdownPosition(dropdown) {
		if(!dropdown.classList.contains('show')) {
			return;
		}
		const dropdownOffset = this.getElOffset(dropdown);
		const currentScroll = window.pageYOffset;
		const dropdownBottom = (dropdownOffset.top + dropdown.offsetHeight) - currentScroll;
		const dropdownTop = dropdownOffset.top - currentScroll;
		const headerHeight = this.header.offsetHeight;
		const windowHeight = window.innerHeight;

		if(dropdownTop < headerHeight) {
			dropdown.classList.remove('reverse-pos');
			dropdown.classList.remove('reverse-animation-on');
		}

		if(dropdownBottom > windowHeight) {
			dropdown.classList.add('reverse-pos');
		}
	}

	openDropdownPosition() {
		for (let i = 0; i < this.allDropdowns.length; i++) {
			const element = this.allDropdowns[i];

			this.setDropdownPosition(element);
		}
	}

	openDropdown(dropdown) {
		dropdown.classList.add('show');
		this.setDropdownPosition(dropdown);
		setTimeout(() => {
			if(dropdown.classList.contains('reverse-pos')) {
				dropdown.classList.add('reverse-animation-on');
			}
			dropdown.classList.add('visible');
		});
	}

	closeDropdown(dropdown) {
		dropdown.classList.remove('visible');
		setTimeout(() => {
			if(!dropdown.classList.contains('visible')) {
				dropdown.classList.remove('show');
				dropdown.classList.remove('reverse-pos');
				dropdown.classList.remove('reverse-animation-on');
			}
		}, 400);
	}

	closeMultipleDropdowns(dropdowns, triggers) {
		for (let i = 0; i < dropdowns.length; i++) {
			const element = dropdowns[i];
			this.closeDropdown(element);
		}
		for (let y = 0; y < triggers.length; y++) {
			const element = triggers[y];
			element.classList.remove('open');
		}
	}

	dropdownTriggerEvents() {
		for (let i = 0; i < this.dropDownTriggers.length; i++) {
			const element = this.dropDownTriggers[i];
			const parentEl = element.closest('.block-home-hero__form-item');
			const dropDownEl = parentEl.querySelector('.block-home-hero__form-item-terms');
			const mainParent = parentEl.parentNode;

			element.addEventListener('click', (e) => {
				e.preventDefault();
				if(element.classList.contains('open')) {
					element.classList.remove('open');
					this.closeDropdown(dropDownEl);

					return;
				}
				const dropdowns = mainParent.querySelectorAll('.show');
				const triggers = mainParent.querySelectorAll('.open');

				element.classList.add('open');
				this.closeMultipleDropdowns(dropdowns, triggers);
				this.openDropdown(dropDownEl);
			});
		}
	}

	filterEvents() {
		for (let i = 0; i < this.filterTriggers.length; i++) {
			const element = this.filterTriggers[i];
			const filterVal = element.getAttribute('data-filter');
			const filterLabelVal = element.textContent;

			const parentEl = element.closest('.block-home-hero__form-item');
			const dropDownEl = parentEl.querySelector('.block-home-hero__form-item-terms');
			const triggerEl = parentEl.querySelector('.block-home-hero__form-item-trigger');
			const filterInput = parentEl.querySelector('input');
			const filterLabel = parentEl.querySelector('.block-home-hero__form-item-value');

			element.addEventListener('click', (e) => {
				e.preventDefault();
				triggerEl.classList.remove('open');
				this.closeDropdown(dropDownEl);
				filterInput.value = filterVal;
				filterLabel.textContent = filterLabelVal;
			});
		}
	}

	bodyClickEvent() {
		document.body.addEventListener('click', (e) => {
			if(e.target.closest('.block-home-hero__form-item')) {
				return;
			}

			this.closeMultipleDropdowns(this.allDropdowns, this.dropDownTriggers);
		});
	}

	clearSendValues() {
		[...this.form].forEach(el => {
			el.addEventListener('submit', e => {
				[...el.querySelectorAll('input[type="hidden"]')].forEach(input => {
					if ( !input.value ) {
						input.setAttribute('name', '');
					}
				})
			});
		});
	}

	init() {
		this.dropdownTriggerEvents();
		this.filterEvents();
		this.bodyClickEvent();
		this.clearSendValues();
	}
}
export default new HomeHeroSearchForm();
